import { render } from "./ProductRegisterView.vue?vue&type=template&id=124ea0b8&scoped=true"
import script from "./ProductRegisterView.vue?vue&type=script&lang=js"
export * from "./ProductRegisterView.vue?vue&type=script&lang=js"

import "./ProductRegisterView.vue?vue&type=style&index=0&id=124ea0b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124ea0b8"]])

export default __exports__